import React from 'react';
import {Link} from "react-router-dom";

const NavBarSecond = () => {
    return (
        <nav>
            <ul>
                <Link to = "/categories/accion" className = "link-categorie">Acción</Link>
                <Link to = "/categories/deporte" className = "link-categorie">Deporte</Link>
                <Link to = "/categories/terror" className = "link-categorie">Terror</Link>
                <Link to = "/categories/aventura" className = "link-categorie">Aventura</Link>
            </ul>
        </nav>


    );
}
 
export default NavBarSecond;